import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  crearOrganizacion,
  darDeBajaOrganizacion,
  reactivarOrganizacion,
  renombrarOrganizacion,
  type CrearOrganizacionInput,
} from "../services/organizaciones-service";

export function useCrearOrganizacion(opts?: { onCreado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CrearOrganizacionInput) => crearOrganizacion(input),
    onSuccess: (org) => {
      toastExito({ title: "Organización creada", message: `"${org.nombre}" disponible.` });
      void qc.invalidateQueries({ queryKey: qk.adminOrganizaciones });
      opts?.onCreado?.();
    },
    onError: toastErrorApi,
  });
}

export function useRenombrarOrganizacion(opts?: { onRenombrado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, nombre }: { id: string; nombre: string }) => renombrarOrganizacion(id, nombre),
    onSuccess: () => {
      toastExito({ title: "Nombre actualizado", message: "Cambios guardados." });
      void qc.invalidateQueries({ queryKey: qk.adminOrganizaciones });
      opts?.onRenombrado?.();
    },
    onError: toastErrorApi,
  });
}

export function useDarDeBajaOrganizacion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string; nombre: string }) => darDeBajaOrganizacion(id),
    onSuccess: (_data, vars) => {
      toastExito({ title: `${vars.nombre} dada de baja`, message: "La organización quedó inactiva." });
      void qc.invalidateQueries({ queryKey: qk.adminOrganizaciones });
    },
    onError: toastErrorApi,
  });
}

export function useReactivarOrganizacion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string; nombre: string }) => reactivarOrganizacion(id),
    onSuccess: (_data, vars) => {
      toastExito({ title: `${vars.nombre} reactivada`, message: "Disponible para nuevas solicitudes." });
      void qc.invalidateQueries({ queryKey: qk.adminOrganizaciones });
    },
    onError: toastErrorApi,
  });
}
